module.exports = __webpack_public_path__ + "img/downAts.0d3befdc.svg";